<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='住培生信息' url='/person/stu/list'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">管理单元：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.secretarysec" filterable placeholder="全部" @change="ManageSecChange">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">轮转科室：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.stusec" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in secOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <SearchNormalText v-model='condition.stuname' label='姓名'></SearchNormalText>
          <SearchNormalText v-model='condition.stuno' label='工号'></SearchNormalText>
          <ZPGLSearchDictItemSelect v-model='condition.stuspec' label='专业' :dictid='this.$utils.DictEnum.specialty'></ZPGLSearchDictItemSelect>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">培养年限：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.stueduyear" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in trainingyearOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <ZPGLSearchDictItemSelect v-model='condition.stuyear' label='届别' :dictid='this.$utils.DictEnum.stuyear'></ZPGLSearchDictItemSelect>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">是否本院人员：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.stuismeals" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in mealOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">住宿：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.stuislive" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in accommodationOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">培训状态：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.stueditstatus" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in stueditstatusOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
          <SearchButton :url="searchUrl" ref="btnSearch"></SearchButton>
          <ImportButton url="/person/stu/import" buttonname="导入"></ImportButton>
          <ExportButton :url='exportUrl' buttonname="导出"></ExportButton>
          <!-- <el-button type="success" icon="el-icon-upload2" @click="Puts()">批量上报</el-button> -->
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" ref="multipleTable" :data="tableData" stripe style="width: 100%;" size="medium"
            @selection-change="handleSelectionChange">
            <!-- <el-table-column type="selection" width="55">
            </el-table-column> -->
            <el-table-column>
              <template slot="header">
                姓名<br>工号
              </template>
              <template slot-scope="scope">
                {{scope.row.StuName}}<br>{{scope.row.StuNo}}
              </template>
            </el-table-column>
            <el-table-column prop="ManageSecName" label="管理单元">
            </el-table-column>
            <el-table-column prop="SectionName" label="轮转科室">
            </el-table-column>
            <el-table-column>
              <template slot="header">
                专业<br>届别
              </template>
              <template slot-scope="scope">
                {{scope.row.SpecialityName}}<br>{{scope.row.StuYearName}}
              </template>
            </el-table-column>
            <el-table-column>
              <template slot="header">
                用户类型<br>培养年限
              </template>
              <template slot-scope="scope">
                {{scope.row.UserTypeName}}<br>{{scope.row.StuEduYearName}}
              </template>
            </el-table-column>
            <el-table-column prop="StuLeave" label="请假天数" width="100">
            </el-table-column>
            <el-table-column label="是否本院人员" width="120">
              <template slot-scope="scope">
                <span v-bind:style="scope.row.MealName == '是'?'color:green;':'color:red;'">{{scope.row.MealName}}</span>
                <el-button @click="ChangeMeal(scope.row)" type="text" size="medium">[变更]</el-button>
              </template>
            </el-table-column>
            <el-table-column label="住宿" width="100">
              <template slot-scope="scope">
                <span v-bind:style="scope.row.LiveName == '有'?'color:green;':'color:red;'">{{scope.row.LiveName}}</span>
              </template>
            </el-table-column>
            <el-table-column label="培训状态" width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.StuEditStatus == 1 || scope.row.StuEditStatus == 5">
                  <span>{{scope.row.StuEditStatusName}}</span>
                </div>
                <div v-if="scope.row.StuEditStatus == 2">
                  <span style="color: green;">{{scope.row.StuEditStatusName}}</span>
                </div>
                <div v-if="scope.row.StuEditStatus == 3">
                  <span style="color: red;">{{scope.row.StuEditStatusName}}</span>
                </div>
                <div v-if="scope.row.StuEditStatus == 4">
                  <span style="color: #D79100;">{{scope.row.StuEditStatusName}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button @click="Edit(scope.row)" type="text" size="medium">修改</el-button>
                <el-button @click="Delete(scope.row)" type="text" size="medium" style="color: red;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StuList',
    data() {
      return {
        condition: {
          username: '',
          rolelevel: '',
          secid: '',
          stuname: '',
          stusec: '',
          stuno: '',
          stuspec: '',
          stuismeals: '',
          stuislive: '',
          stueduyear: '',
          stueditstatus: '',
          token: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true,
          stuyear: '',
          secretarysec: ''
        },
        secOptions: [],
        managesecOptions: [],
        mealOptions: [{
          value: '1',
          label: '是'
        }, {
          value: '2',
          label: '否'
        }],
        accommodationOptions: [{
          value: '1',
          label: '有'
        }, {
          value: '2',
          label: '无'
        }],
        trainingyearOptions: [{
          value: '1',
          label: '一年生'
        }, {
          value: '2',
          label: '两年生'
        }, {
          value: '3',
          label: '三年生'
        }, {
          value: '4',
          label: '往届生'
        }],
        stueditstatusOptions: [{
          value: '1',
          label: '未入科'
        }, {
          value: '2',
          label: '在培'
        }, {
          value: '3',
          label: '缺勤'
        }, {
          value: '4',
          label: '延期'
        }, {
          value: '5',
          label: '已结业'
        }],
        multipleSelection: [],
        multipleSelectionAll: [],
        idKey: 'StuID',
        tableData: null,
        searchUrl: this.$utils.Url.zpgl + '/api/APIStu/List',
        exportUrl: this.$utils.Url.zpgl + '/api/APIStu/ListOut',
        loading: true
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.changePageCoreRecordData()
        this.condition.currentPage = val
        this.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.changePageCoreRecordData()
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.Search()
      },
      Edit: function(row) {
        this.$router.push({
          name: 'StuEdit',
          params: {
            id: row.StuID
          }
        })
      },
      Delete: function(row) {
        var args = {
          id: row.StuID,
          token: this.condition.token
        }
        this.$utils.Delete(this.$utils.Url.zpgl + '/api/APIStu/Delete', args, row.StuName, this.$refs.btnSearch.Search)
      },
      ChangeMeal: function(row) {
        var stuname = row.StuName
        var StuIsMeals = 1
        if (row.StuIsMeals === 1) {
          StuIsMeals = 2
        }
        var args = {
          id: row.StuID,
          stuismeals: StuIsMeals,
          updatetype: 'changemeal',
          token: this.condition.token
        }
        this.$utils.Change(this.$utils.Url.zpgl + '/api/APIStu/Update', args, '确定变更' + stuname + '的餐费状态?', this.$refs
          .btnSearch.Search)
      },
      Search: function(index) {
        this.loading = true
        if (index != null) {
          this.condition.currentPage = 1
        }
        this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/List', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              this.tableData = res.data.Data
              this.condition.recordCount = res.data.Pager.RecordCount
              setTimeout(() => {
                this.setSelectRow()
              }, 200)
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            this.tableData = null
            this.condition.recordCount = 0
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
            this.loading = false
          })
      },
      handleSelectionChange: function(val) {
        this.multipleSelection = val
      },
      setSelectRow: function() {
        if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
          return
        }
        // 标识当前行的唯一键的名称
        let idKey = this.idKey
        let selectAllIds = []
        this.multipleSelectionAll.forEach(row => {
          selectAllIds.push(row[idKey])
        })
        this.$refs.multipleTable.clearSelection()
        for (var i = 0; i < this.tableData.length; i++) {
          if (selectAllIds.indexOf(this.tableData[i][idKey]) >= 0) {
            this.$refs.multipleTable.toggleRowSelection(this.tableData[i], true)
          }
        }
      },
      changePageCoreRecordData: function() {
        // 标识当前行的唯一键的名称
        let idKey = this.idKey
        let that = this
        // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
        if (this.multipleSelectionAll.length <= 0) {
          this.multipleSelectionAll = this.multipleSelection
          return
        }
        // 总选择里面的key集合
        let selectAllIds = []
        this.multipleSelectionAll.forEach(row => {
          selectAllIds.push(row[idKey])
        })
        let selectIds = []
        // 获取当前页选中的id
        this.multipleSelection.forEach(row => {
          selectIds.push(row[idKey])
          // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
          if (selectAllIds.indexOf(row[idKey]) < 0) {
            that.multipleSelectionAll.push(row)
          }
        })
        let noSelectIds = []
        // 得到当前页没有选中的id
        this.tableData.forEach(row => {
          if (selectIds.indexOf(row[idKey]) < 0) {
            noSelectIds.push(row[idKey])
          }
        })
        noSelectIds.forEach(id => {
          if (selectAllIds.indexOf(id) >= 0) {
            for (let i = 0; i < that.multipleSelectionAll.length; i++) {
              if (that.multipleSelectionAll[i][idKey] === id) {
                // 如果总选择中有未被选中的，那么就删除这条
                that.multipleSelectionAll.splice(i, 1)
                break
              }
            }
          }
        })
      },
      Put: function(row) {
        var args = {
          token: this.condition.token,
          id: row.StuID
        }
        this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/Put', args)
          .then(res => {
            console.log(res.data)
            if (res.data.Code === 0) {
              this.$message({
                message: '上报成功',
                type: 'success'
              })
              this.Search()
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Data,
                type: 'error'
              })
            }
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '上报失败',
              type: 'error'
            })
          })
      },
      Puts: function() {
        if (this.multipleSelection.length == 0) {
          this.$message({
            message: '没有选择任何住培生',
            type: 'error'
          })
          return
        }
        var message = "确定将选中的人员信息上报至HIS吗"
        this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var args = {
            token: this.condition.token,
            multipleSelection: this.multipleSelection,
          }
          this.$http.post(this.$utils.Url.zpgl + '/api/APIStu/Puts', args)
            .then(res => {
              console.log(res.data)
              if (res.data.Code === 0) {
                this.$message({
                  message: '上报成功',
                  type: 'success'
                })
                this.Search()
              } else {
                this.$message({
                  message: res.data.Msg + '，' + res.data.Data,
                  type: 'error'
                })
              }
            })
            .catch(err => {
              console.log(err)
              this.$message({
                message: '上报失败',
                type: 'error'
              })
            })
        }).catch(() => {})
      },
      LoadManageSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
        }, null, null, null)
      },
      ManageSecChange: function() {
        this.condition.section = ''
        this.secOptions = []
        this.LoadCPSec()
      },
      LoadCPSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel,
          mamagesec: this.condition.secretarysec
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CPSecList', args, function(data) {
          that.secOptions = data.Data
        }, null, null, null)
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.condition.secid = sessionStorage.getItem('secid')
      this.LoadManageSec()
      this.LoadCPSec()
      this.Search()
    }
  }
</script>

<style scoped="scoped">
  /deep/.el-table .cell {
    line-height: 20px;
  }
</style>
